export interface RotationOptions {
  duration?: number
  degrees: number
}

const DEFAULT_ROTATION_DURATION = 0.4

export const useRotation = (rotated: boolean, options: RotationOptions) => ({
  transition: `transform ${
    options.duration ?? DEFAULT_ROTATION_DURATION
  }s ease-in-out`,
  transform: rotated ? `rotate(${options.degrees}deg)` : undefined,
})
